import React from "react";
import ReactDOM from "react-dom/client";
import App from "@features/app/App";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

// Safer ReactDOM render with error boundary
const renderApp = () => {
  const RECAPTCHA_SITE_KEY = "6LcmIKssAAAAAIhLBuqLoaZegWInDtnxs_IQLXI-";

  try {
    ReactDOM.createRoot(rootElement).render(
      // <React.StrictMode>
      <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
        <App />
      </GoogleReCaptchaProvider>,
      //  </React.StrictMode>
    );
  } catch (error) {
    console.error("Failed to render app:", error);
    // Fallback rendering without StrictMode
    ReactDOM.createRoot(rootElement).render(<App />);
  }
};

renderApp();
